import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=f9ac1ce6&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ac1ce6",
  null
  
)

export default component.exports